var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1484 2.64844C19.8047 2.64844 20.3516 2.88542 20.7891 3.35938C21.263 3.79688 21.5 4.34375 21.5 5V21.3516C21.5 21.9714 21.263 22.5182 20.7891 22.9922C20.3516 23.4297 19.8047 23.6484 19.1484 23.6484H2.85156C2.19531 23.6484 1.63021 23.4297 1.15625 22.9922C0.71875 22.5182 0.5 21.9714 0.5 21.3516V5C0.5 4.34375 0.71875 3.79688 1.15625 3.35938C1.63021 2.88542 2.19531 2.64844 2.85156 2.64844H4V0.351562H6.35156V2.64844H15.6484V0.351562H18V2.64844H19.1484ZM19.1484 21.3516V9.64844H2.85156V21.3516H19.1484ZM7.5 14.3516V12H5.14844V14.3516H7.5ZM12.1484 14.3516V12H9.85156V14.3516H12.1484ZM16.8516 14.3516V12H14.5V14.3516H16.8516ZM7.5 19V16.6484H5.14844V19H7.5ZM12.1484 19V16.6484H9.85156V19H12.1484ZM16.8516 19V16.6484H14.5V19H16.8516Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMonth);
export default __webpack_public_path__ + "static/media/calendar_month.25f00c1b45a67a1c9bfb95fbffab4dc8.svg";
export { ForwardRef as ReactComponent };